import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className,
  variant = 'primary',
  size = 'md',
  isLoading,
  children,
  ...props
}, ref) => {
  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm border border-transparent',
    secondary: 'bg-slate-900 text-white hover:bg-slate-800 shadow-sm border border-transparent',
    outline: 'bg-transparent border border-slate-200 text-slate-900 hover:bg-slate-50',
    ghost: 'bg-transparent text-slate-600 hover:text-slate-900 hover:bg-slate-100'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button ref={ref} className={cn('inline-flex items-center justify-center rounded-full font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], className)} disabled={isLoading || props.disabled} {...props} data-id="element-235">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-236" />}
        {children}
      </button>;
});
Button.displayName = 'Button';